import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { ErrorIllustration2 } from '../icons/icons';
import { unsafeHTML } from 'lit/directives/unsafe-html';
import { DepInjMixin } from '@APP/mixins/dependency';
import { QuestionsService } from '@APP/services/questions-service';

type Deps = {
  questionsService: QuestionsService;
};
@customElement('non-eligible-popup-instanda')
export class NonEligiblePopup extends DepInjMixin<Deps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      commonPopupStyle,
      css`
        .title {
          font-size: 9rem;
          font-weight: 700;
      margin-bottom: 0;
    }

    .sub-title {
      font-size: 4rem;
      font-weight: 700;
      margin-bottom: 2rem;
      max-width: 61.375rem;
      color: var(--c-text-sub);
    }

    .message {
      margin: 0;
      max-width: 53.25rem;
      color: var(--c-text);
    }
    svg, img{
    max-width: 26.5rem;
    max-height: 36.5rem;
    }
    `,
    ];
  };

  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }

  @property({ type: String })
    value: string = '';

  renderMobileLayout() {
    return html`
      <div class="grid-container">
       <div class="col-1">
        <h1 class="title">${t('Oops..')}</h1>
        <h2 class="sub-title">${t('Something went wrong')}</h2>
       </div>
       <div class="col-2">
        ${ErrorIllustration2}
      </div>
      <div class="col-3">
       <h2 class="message">${unsafeHTML(t('E_Rating_1', this.deps.questionsService.model.getSupportPhoneNumberText()))}</h2>
      </div>
     </div>
    `;
  }

  renderDesktopLayout() {
    return html`
       <div class="grid-container">
       <div class="col-1"></div>
       <div class="col-2">
        <h1 class="title">${t('Oops..')}</h1>
        <h2 class="sub-title">${t('Something went wrong')}</h2>
        <h2 class="message">${unsafeHTML(t('E_Rating_1', this.deps.questionsService.model.getSupportPhoneNumberText()))}</h2>
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
